import { useEffect, useRef, useState } from "react";
import DistrictEdit from "./district-entry";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import {
  Grid,
  GridCellProps,
  GridColumn,
  GridColumnMenuFilter,
  GridColumnMenuProps,
  GridDataStateChangeEvent,
  GridExpandChangeEvent,
  GridNoRecords,
} from "@progress/kendo-react-grid";

import {
  setExpandedState,
  setGroupIds,
} from "@progress/kendo-react-data-tools";
import { DataResult, process, State } from "@progress/kendo-data-query";
import { useGetDistrict } from "../../apiclient/master/useGetDistrictApi";
import { url } from "inspector";
import DistrictModel from "../../models/masters/district-model";
import { SubmitStatus } from "../../core/formik-model-dialog.component";
import { API_END_POINT } from "../../constants";
import { GridCommandCell } from "../../core/grid-command-cell.component";
import { LoadingIndicator } from "../../core/loading-indicator.component";
import {
  DeleteModelDialog,
  DeletePostDataInfo,
  DeleteStatus,
} from "../../core/delete-model-dialog.component";
import DistrictEntry from "./district-entry";
import { GridActionComponent } from "../../core/action.title.component";

export const addOrUpdateArrayItem = (data: any[], item: any, key: string) => {
  const newData = data ? [...data] : [];
  const index = data?.findIndex((d) => d[key] === item[key]);
  console.log("the index is" + index);
  if (index > -1) {
    newData.splice(index, 1, item);
  } else {
    newData.push(item);
  }
  return newData;
};

const DistrictPage: React.FC = () => {
  const initialDataState: State = {
    take: 10,
    skip: 0,
    group: [],
  };
  const [dataState, setDataState] = useState<State>(initialDataState);
  const [deleteDistrictData, setDeleteDistrictData] =
    useState<DeletePostDataInfo>();
  const [collapsedState, setCollapsedState] = useState<string[]>([]);
  const [resultData, setResultData] = useState<DataResult>();

  const [editModal, setEditModal] = useState<boolean>(false);
  const [editData, setEditdata] = useState<DistrictModel>(null);
  const exportExcel = useRef<ExcelExport | null>(null);
  const [viewModal, setViewModal] = useState<boolean>(false);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const [pgreset, setpgreset] = useState<boolean>(false);

  const {
    data: result,
    isLoading,
    isError,
    refetch: realoadDistrict,
  } = useGetDistrict();

  const processWithGroups = (data: DistrictModel[], dataState: State) => {
    const groups = dataState.group;
    dataState.group = groups;
    const newDataState = process(data, dataState);
    setGroupIds({ data: newDataState.data, group: dataState.group });
    return newDataState;
  };

  const fetchData = async () => {
    try {
      setIsRefreshing(true);
      const { data, error } = await realoadDistrict();
      if (error) {
        console.error("Error reloading:", error);
      } else {
        console.log("Reloaded data:", data);
      }
    } catch (err) {
      console.error("Unexpected error:", err);
    } finally {
      setIsRefreshing(false);
    }
  };

  useEffect(() => {
    setEditdata(null);
    fetchData();
    if (result) {
      setResultData(processWithGroups(result, initialDataState));
    }
  }, [result]);

  let newData: any = null;
  if (resultData) {
    newData = setExpandedState({
      data: resultData.data,
      collapsedIds: collapsedState,
    });
  }

  const onSaveComplete = (status: SubmitStatus, data: DistrictModel) => {
    if (status === SubmitStatus.Completed) {
      realoadDistrict();
      setResultData(processWithGroups(newData, dataState));
    }
    setEditdata(null);
  };

  const excelExport = () => {
    if (exportExcel.current !== null) {
      exportExcel.current.save();
    }
  };

  const onAddNew = () => {
    setEditModal(true);
    setEditdata(new DistrictModel());
  };

  const onEdit = (data: DistrictModel) => {
    setEditModal(true);
    setViewModal(false);
    setEditdata(data);
  };

  const onView = (data: DistrictModel) => {
    setViewModal(true);
    setEditdata(data);
  };

  const onRemove = (data: DistrictModel) => {
    const { districtId } = data;
    console.log(data);
    setDeleteDistrictData({
      data,
      route: `District/DeleteDistrict/${districtId}`,
      endpoint: API_END_POINT.MASTER,
    });
    realoadDistrict();
  };

  const onDeleteComplete = (status: DeleteStatus, data: DistrictModel) => {
    if (status === DeleteStatus.Completed) {
      realoadDistrict();
      setResultData(processWithGroups(result, dataState));
    }
    setDeleteDistrictData(null);
  };
  const ColumnMenu = (props: GridColumnMenuProps) => {
    return (
      <div>
        <GridColumnMenuFilter {...props} expanded={true} />
      </div>
    );
  };

  const CommandCell = (props: GridCellProps) => (
    <GridCommandCell
      {...props}
      edit={onEdit}
      remove={onRemove}
      add={onAddNew}
      view={onView}
      dataItem={props.dataItem}
      idPropertyName="districtId"
      editPermissionName={null}
      deletePermissionName={null}
    />
  );

  const onSearch = (e: any) => {
    if (e.target.value.length > 0) {
      const searchKey: string = e.target.value;
      const filteredData = result?.filter(
        (p) =>
          //  p?.code?.toLowerCase().includes(searchKey?.toLowerCase()) ||
          p?.name?.toLowerCase().includes(searchKey?.toLowerCase())
        //p?.description?.toLowerCase().includes(searchKey?.toLowerCase())
      );
      setResultData(process(filteredData, dataState));
    } else {
      setResultData(process(result, dataState));
    }
  };

  const expandChange = (event: GridExpandChangeEvent) => {
    const item = event.dataItem;

    if (item.groupId) {
      const newCollapsedIds = !event.value
        ? [...collapsedState, item.groupId]
        : collapsedState.filter((groupId) => groupId !== item.groupId);
      setCollapsedState(newCollapsedIds);
    }
  };

  const ColumnFormatBoolean = (props: any) => {
    return (
      <td
        {...props.tdProps}
        colSpan={1}
        style={{
          color: "black",
        }}
      >
        {props.children === "true" ? (
          <span style={{ color: "green", fontWeight: "bold" }}>Yes</span>
        ) : (
          <span style={{ color: "red", fontWeight: "bold" }}>No</span>
        )}
      </td>
    );
  };
  const refreshGrid = () => {
    realoadDistrict();
  };
  const dataStateChange = (event: GridDataStateChangeEvent) => {
    const newDataState = processWithGroups(result, event.dataState);
    setResultData(newDataState);
    setDataState(event.dataState);
  };
  const onAddClick = () => {
    setEditModal(true);
    setViewModal(false);
    setEditdata(new DistrictModel());
  };

  let grid = null;
  if (result) {
    grid = (
      <Grid
        data={newData}
        pageable={{ pageSizes: [10, 20, 50, 100] }}
        total={resultData?.total}
        groupable={true}
        sortable={true}
        onDataStateChange={dataStateChange}
        {...dataState}
        onExpandChange={expandChange}
        columnVirtualization={false}
        resizable={true}
      >
        {/* <GridToolbar className="export-bg">
       
        </GridToolbar> */}
        <GridColumn
          field="code"
          title="Code"
          columnMenu={ColumnMenu}
        />
        <GridColumn
          field="name"
          title="Name"
          columnMenu={ColumnMenu}
        />
        <GridColumn
          field="capital"
          title="Capital"
          columnMenu={ColumnMenu}
        />

        {/*  <GridColumn
                    width={"450px"}
                    field="ordinal"
                    title="Ordinal"
                    columnMenu={ColumnMenu}
                /> */}

        <GridColumn
          cell={CommandCell}
          title="Action"
          groupable={true}
        />
        <GridNoRecords>
          <div className="mt-2" style={{ width: "100%", height: "500px" }}>
            <center>
              <h5>No data found</h5>
            </center>
          </div>
        </GridNoRecords>
      </Grid>
    );
    if (isError) {
      return (
        <div>
          <h4>Error Loadong Page..</h4>
        </div>
      );
    }
    return (
      <>
        <div
          style={{ minHeight: "600px" }}
          className="card p-3 border-0 m-3 sw-shadow radius-15"
        >
          <div>
            <GridActionComponent
              onSearchClick={onSearch}
              addButtonClick={onAddClick}
              excelExportClick={excelExport}
              refreshClick={fetchData}
              title="DISTRICT"
              addButtonTooltip="Add District"
            ></GridActionComponent>

          </div>

          {editModal && (
            <DistrictEntry data={editData} isViewMode={viewModal} onClose={onSaveComplete} />
          )}
          {viewModal && (
            <DistrictEntry
              isViewMode={true}
              data={editData}
              onClose={onSaveComplete}
            />
          )}
          {deleteDistrictData && (
            <DeleteModelDialog
              title="Delete District"
              deleteData={deleteDistrictData}
              onClose={onDeleteComplete}
            >
              <div>
                Are you sure you want to delete District :{" "}
                <span style={{ fontWeight: "bold" }}>
                  {deleteDistrictData.data.name}
                </span>
                ?
              </div>
            </DeleteModelDialog>
          )}

<div>
            <>
              {isRefreshing || isLoading ? (
                <LoadingIndicator isLoading={isRefreshing}></LoadingIndicator>
              ) : (
                <div>
                  {grid}
                  <ExcelExport
                fileName={"District_List"}
                data={result}
                ref={exportExcel}
              >
                <ExcelExportColumn width={100} field="code" title="Code" />
                <ExcelExportColumn
                  width={100}
                  field="name"
                  title="District"
                />
                <ExcelExportColumn
                  width={100}
                  field="capital"
                  title="Capital"
                />
                <ExcelExportColumn
                  width={100}
                  field="stateName"
                  title="State"
                />
              </ExcelExport>
              </div>
              )}
            </>
          </div>
          <div></div>
        </div>
      </>
    );
  }
};
export default DistrictPage;
